import { createAction } from 'redux-actions'
import { notification } from '../services/helpers'
import api from '@vmockinc/dashboard/services/api'
import { push } from 'react-router-redux'
import _ from 'underscore'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'

const PREFIX = 'Edit.'

export const PROCESS_EDITED_DATA_INIT = PREFIX + 'PROCESS_EDITED_DATA_INIT'
export const PROCESS_EDITED_DATA_DONE = PREFIX + 'PROCESS_EDITED_DATA_DONE'
export const PROCESS_EDITED_DATA_FAIL = PREFIX + 'PROCESS_EDITED_DATA_FAIL'
export const UPDATE_EDITED_DATA_STATE = PREFIX + 'UPDATE_EDITED_DATA_STATE'

export const processEditedDataInit = createAction(PROCESS_EDITED_DATA_INIT)
export const processEditedDataDone = createAction(PROCESS_EDITED_DATA_DONE)
export const processEditedDataFail = createAction(PROCESS_EDITED_DATA_FAIL)
export const updateEditedDataState = createAction(UPDATE_EDITED_DATA_STATE)

const timeOutMilliseconds = 2000

export function processEditedData(
  fetchId,
  sectionName,
  currentIndex,
  countSections,
  newSubSection,
  data,
  uid,
  prevData,
  score,
  deleteSubSection,
  emptyMessage,
  intl
) {
  let dataObj = _.extend({}, data)
  if (emptyMessage !== false) {
    notification(emptyMessage, 'error', timeOutMilliseconds)
    sendTrackingData(
      'process',
      'aspire_actions',
      'notify_error',
      'empty_edit_section'
    )
    return (dispatch) => {}
  }

  if (deleteSubSection !== true) {
    let flag = false

    for (let entity in dataObj) {
      if (_.isString(dataObj[entity]) && !_.isEmpty(dataObj[entity].trim())) {
        flag = true
        break
      }
    }

    if (JSON.stringify(dataObj) === JSON.stringify(prevData)) flag = false

    const sectionIdMap = {
      "Profile Picture": "aspire.logscreenNames.profilePicture",
      "Personal Information": "aspire.logscreenNames.personalInformation",
      "Headline": "aspire.logscreenNames.headline",
      "Summary": "aspire.logscreenNames.summary",
      "Experience": "aspire.logscreenNames.experience",
      "Education": "aspire.logscreenNames.education"
    };

    const id = sectionIdMap[sectionName] || sectionName;

    if (flag === false) {
      notification(
        intl.formatMessage(
          {id: 'aspire.profileData.emptyMessage.sectionNotEdited'},
          {sectionName: intl.formatMessage({id: id, defaultMessage: sectionName})}
        ),
        'error',
        timeOutMilliseconds
      )
      sendTrackingData(
        'process',
        'aspire_actions',
        'notify_error',
        'section_not_edited'
      )
      return (dispatch) => {}
    }
  }

  if (sectionName !== 'Profile Picture') {
    for (let entity in dataObj) {
      dataObj[entity] = dataObj[entity]
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    }
  }

  let editInfo = {
    section_name: sectionName,
    sub_section_id: currentIndex,
    new_sub_section: newSubSection,
    delete_sub_section: deleteSubSection,
  }

  return (dispatch, getState) => {
    dispatch(processEditedDataInit(editInfo))

    return api
      .service('ap')
      .post(`aspire/edit-section`, {
        fetch_id: fetchId,
        section_name: sectionName,
        sub_section_id: currentIndex,
        count_sections: countSections,
        new_sub_section: newSubSection,
        data: JSON.stringify(dataObj),
        sub_section_uid: uid,
        prev_data: JSON.stringify(prevData),
        score: score,
        delete_sub_section: deleteSubSection,
      })
      .done((response) => {
        notification(
          intl.formatMessage({id: 'aspire.editData.processingStartedMessage', defaultMessage: 'Processing started.'}),
          'information', timeOutMilliseconds)
        let jsonObjectForTracking = {
          eventLabel: 'processing_started',
          sectionName: sectionName,
          subSectionId: currentIndex,
          newSubSection: newSubSection,
          deleteSubSection: deleteSubSection,
        }
        sendTrackingData(
          'process',
          'aspire_actions',
          'notify_success',
          JSON.stringify(jsonObjectForTracking)
        )
        dispatch(processEditedDataDone(response))
      })
      .fail((xhr) => {
        notification(
          intl.formatMessage({id: 'aspire.editData.failedToProcessSectionMessage', defaultMessage: 'Failed to process section.'}),
          'error', timeOutMilliseconds)
        let jsonObjectForTracking = {
          eventLabel: 'failed_to_process_section',
          sectionName: sectionName,
          subSectionId: currentIndex,
          newSubSection: newSubSection,
          deleteSubSection: deleteSubSection,
        }
        dispatch(processEditedDataFail())
        sendTrackingData(
          'process',
          'aspire_actions',
          'notify_error',
          JSON.stringify(jsonObjectForTracking)
        )
      })
  }
}

export const SHOW_URL_EDIT_MODAL = PREFIX + 'SHOW_URL_EDIT_MODAL'
const showUrlEditModalDone = createAction(SHOW_URL_EDIT_MODAL)

export function showUrlEditModal($flag) {
  return (dispatch) => {
    dispatch(showUrlEditModalDone($flag))
  }
}

export const SHOW_EDIT_MODAL = PREFIX + 'SHOW_EDIT_MODAL'
const showEditModalDone = createAction(SHOW_EDIT_MODAL)

export function showEditModal(isShowModal, activeEditSection) {
  return (dispatch) => {
    dispatch(showEditModalDone({ isShowModal, activeEditSection }))
  }
}

export const CHANGE_EDIT_PROFILE_PIC_INITIAL_STATE =
  PREFIX + 'CHANGE_EDIT_PROFILE_PIC_INITIAL_STATE'
const changeProfilePicInitialEditStateDone = createAction(
  CHANGE_EDIT_PROFILE_PIC_INITIAL_STATE
)

export function changeProfilePicInitialEditState(modalState) {
  return (dispatch) => {
    dispatch(changeProfilePicInitialEditStateDone(modalState))
  }
}

export const EXPAND_LEFT_NAV = PREFIX + 'EXPAND_LEFT_NAV'
const expandLeftNavDone = createAction(EXPAND_LEFT_NAV)

export function expandLeftNav(isExpand) {
  return (dispatch) => {
    dispatch(expandLeftNavDone(isExpand))
  }
}

export const TOGGLE_RIGHT_NAV = PREFIX + 'TOGGLE_RIGHT_NAV'
const toggleRightNavDone = createAction(TOGGLE_RIGHT_NAV)

export function toggleRightNav(isExpand) {
  return (dispatch) => {
    dispatch(toggleRightNavDone(isExpand))
  }
}

export const SHOW_LOG_MODAL = PREFIX + 'SHOW_LOG_MODAL'
const showLogModalDone = createAction(SHOW_LOG_MODAL)

export function showLogModal(isShowLogModal) {
  return (dispatch) => {
    dispatch(showLogModalDone({ isShowLogModal: isShowLogModal }))
  }
}
